import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './Input.module.css';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ className, ...rest }, ref) => (
    <input ref={ref} className={clsx(styles.root, className)} {...rest} />
  )
);

Input.displayName = 'Input';
